import { Option } from "../models/option.model";

/**
 * PURPOSE: houses all the various lines of business codes and display names
 */
export abstract class BusinessLines {
  public static commercialBusinessLines: Option[] = [
    { field: "CAUT", displayName: "Commercial Auto" },
    { field: "CBND", displayName: "Bonds" },
    { field: "CBPY", displayName: "Business Owners Package (BOP)" },
    { field: "CBRS", displayName: "Builders Risk" },
    { field: "CCYB", displayName: "Cyber Liability" },
    { field: "CDO", displayName: "Directors and Officers" },
    { field: "CELY", displayName: "Employment Practices Liability" },
    { field: "CGLY", displayName: "General Liability" },
    { field: "CMAR", displayName: "Inland Marine" },
    { field: "CPLY", displayName: "Professional Liability" },
    { field: "CPTY", displayName: "Property" },
    { field: "CUMB", displayName: "Umbrella / Excess" },
    { field: "CWCP", displayName: "Workers' Compensation" },
    { field: "CERR", displayName: "Errors & Omissions" },
    { field: "LAH", displayName: "Accident & Health" },
    { field: "COEQ", displayName: "Contractors Equipment" },
    { field: "BUSI", displayName: "Other" }
  ];

  public static personalBusinessLines: Option[] = [
    { field: "ATV", displayName: "ATV" },
    { field: "AUTO", displayName: "Automobile" },
    { field: "BOAT", displayName: "Boat" },
    { field: "CNDO", displayName: "Condo" },
    { field: "COLA", displayName: "Collectible Auto" },
    { field: "EQKE", displayName: "Earthquake" },
    { field: "EVNT", displayName: "Special Event" },
    { field: "FARM", displayName: "Farm" },
    { field: "FLOD", displayName: "Flood" },
    { field: "GIDR", displayName: "Personal Watercraft" },
    { field: "HLTH", displayName: "Health" },
    { field: "HOME", displayName: "Home" },
    { field: "IFRD", displayName: "Identity Fraud" },
    { field: "LAND", displayName: "Vacant Land" },
    { field: "LORD", displayName: "Landlord" },
    { field: "MOBI", displayName: "Mobile Home" },
    { field: "MOTO", displayName: "Motorcycle" },
    { field: "OTHE", displayName: "Other" },
    { field: "PBRS", displayName: "Builders Risk/Home Construction" },
    { field: "PETS", displayName: "Pet" },
    { field: "RENT", displayName: "Renters" },
    { field: "RV", displayName: "RV" },
    { field: "SHRT", displayName: "Short-Term/Sharing" },
    { field: "SNOW", displayName: "Snowmobile" },
    { field: "TRLR", displayName: "Trailer" },
    { field: "UMBR", displayName: "Umbrella" },
    { field: "VALU", displayName: "Valuable Items" }
  ];

  public static lifeAndAnnuitiesBusinessLines: Option[] = [
    { field: "LTCI", displayName: "Long Term Care Insurance" },
    { field: "DBII", displayName: "Disability Income Insurance" },
    { field: "LIFE", displayName: "Life Insurance" },
    { field: "ANNU", displayName: "Annuities" }
  ];
}
